<template>
    <b-modal id="modal-import-ecosystems" title="Import Ecosystems">
        <div class="form">
        <template v-if="typeof errors.file !== 'undefined'">
            <div class="form__error" v-for="(error, index) in errors.file" :key="index">{{error}}</div>
        </template>

        <p v-if="!file" class="modal-text mt-3">Download and use <a :href="baseURL + '/files/add_ecosystems.csv'" target="_blank">this file</a> for best results</p>
            <div class="input-file mb-3">
                <template v-if="!file">
                    <label for="input-file__upload" class="mr-2">Choose File</label>
                    <input type="file" ref="newFile" id="input-file__upload" accept=".csv" v-on:change="handleFileUpload()">
                </template>

                <div v-else class="tags-list tags-list--light">
                    <span class="tags-list__tag mt-3">
                    {{file.name}}
                    <a @click="file = null" class="tags-list__tag__close"></a>
                    </span>
                </div>
            </div>
        </div>

        <template #modal-footer>
            <b-button variant="primary" size="lg" :disabled="!canAdd" @click="add">
                <span v-if="!loading">Import</span>
                <span v-else><b-spinner class="mr-1" small></b-spinner>Loading...</span>
            </b-button>
        </template>
    </b-modal>
</template>

<script>

import ecosystems from "@/services/ecosystems.service"
import Vue from 'vue';
import { baseURL } from '@/axios'

export default {
    data() {
        return {
            errors: {},
            result: "",
            file: null,
            loading: false,
            baseURL
        }
    },

    computed: {
        canAdd() {
            if (this.loading) {
                return false
            }
            else {
                return this.file !== null
            }
        }
    },

    methods: {
        open() {
            this.errors = {}
            this.$bvModal.show('modal-import-ecosystems')
        },

        handleFileUpload() {
            if (this.$refs['newFile'].files.length) {
                this.file = this.$refs['newFile'].files[0]
            }
        },

        add() {
            this.loading = true
            this.errors = {}
            this.result = ""

            let formData = new FormData();
            formData.append('file', this.file)

            ecosystems.addMultipleEcosystems(formData).then(response => {
                this.loading = false
                this.errors = response.data.errors

                if (!Object.keys(this.errors).length) {
                    this.file = null
                    this.$bvModal.hide('modal-import-ecosystems');

                    Vue.notify({
                        group: 'app',
                        type: 'success',
                        text: response.data.result.join(', ')
                    })

                    this.$emit('ecosystems-imported')
                }
            }).catch(() => {
                this.loading = false
            })
        }
    }
}
</script>

<style scoped>

</style>
